import { useEffect } from 'react';
import { useQuery, useQueryClient } from '@tanstack/react-query';
import { useAuthContext } from '@/contexts/AuthContext';
import { contarConversasNaoLidas } from '@/services/mensagens.service';
import { subscribeToInboxChanges, unsubscribeMensagensChannel } from '@/services/whatsapp.service';

/**
 * Contagem (ao vivo) de conversas da org com mensagens por ler. Para o badge do
 * item "Painel" na sidebar (admin/atendente). Realtime via canal do inbox.
 */
export function useConversasNaoLidas(): number {
  const { organizationId, isPrestador } = useAuthContext();
  const queryClient = useQueryClient();
  const enabled = !!organizationId && !isPrestador;

  const query = useQuery({
    queryKey: ['conversas-nao-lidas', organizationId],
    queryFn: contarConversasNaoLidas,
    enabled,
  });

  useEffect(() => {
    if (!enabled || !organizationId) return;
    const channel = subscribeToInboxChanges(
      organizationId,
      () => {
        void queryClient.invalidateQueries({ queryKey: ['conversas-nao-lidas', organizationId] });
      },
      `inbox-badge-${organizationId}`,
    );
    return () => { unsubscribeMensagensChannel(channel); };
  }, [enabled, organizationId, queryClient]);

  return query.data ?? 0;
}
